import Login from "@view/login"
import Error404 from "@view/error/404"
import Layout from "@view/layout"

const app = {
  path: '/app',
  component: Layout,
  meta: {
    subMenu: true,
    icon: "el-icon-menu",
    title: "应用中心",
    permission: ["appMarket","appDevice"],
  },
  children: [
    {
      path: "/app/market",
      name: "appMarket",
      component: () => import("@sub-view/app/market"),
      meta: {
        title: "应用市场",
        permission: ["appMarket"],
      }
    },
    {
      path: "/app/device",
      name: "appDevice",
      component: () => import("@sub-view/app/device"),
      meta: {
        title: "安装应用",
        permission: ["appDevice"],
      }
    }
  ]
};

const voucher = {
  path: '/voucher',
  component: Layout,
  meta: {
    subMenu: true,
    icon: "el-icon-collection-tag",
    title: "代金券管理",
    permission: ["voucherList","voucherOrder"],
  },
  children: [
    {
      path: "/voucher/list",
      name: "voucherList",
      component: () => import("@sub-view/voucher/list"),
      meta: {
        title: "代金券列表",
        permission: ["voucherList"],
      }
    },
    {
      path: "/voucher/order",
      name: "voucherOrder",
      component: () => import("@sub-view/voucher/order"),
      meta: {
        title: "代金券订单",
        permission: ["voucherOrder"],
      }
    },
  ]
};

export const staticRoutes = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  // 未找到页面
  {
    path: '/404',
    name: '404',
    component: Error404,
  },
];

export const defaultRoutes = [
  // 斜杠跳转登录页面
  {
    path: '/',
    redirect: '/index',
    hidden: true
  },
  // 没有页面跳转错误页面
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
];

export const dynamicRoutes = [
  app,
  voucher,
];

export const adminRoutes = [

];
